if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          thumbnailsVertical: this.querySelector('[id^="Slider-Thumbnails-Vertical"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        // Handle vertical thumbnails
        if (this.elements.thumbnailsVertical) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          // Add click handler to both the list item and the button
          this.elements.thumbnailsVertical.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            const mediaId = mediaToSwitch.dataset.target;
            if (mediaId) {
              // Handle click on the list item
              mediaToSwitch.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.setActiveMedia(mediaId, false);
              });
              
              // Also handle click on the button inside
              const button = mediaToSwitch.querySelector('button');
              if (button) {
                button.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setActiveMedia(mediaId, false);
                });
              }
            }
          });
        }
        
        if (!this.elements.thumbnails) return;

        if (!this.elements.thumbnailsVertical) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        }
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;
        // Handle vertical thumbnails
        if (this.elements.thumbnailsVertical) {
          const verticalThumbnail = this.elements.thumbnailsVertical.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveVerticalThumbnail(verticalThumbnail);
        }
        // Handle horizontal thumbnails
        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        
        // For vertical thumbnails layout, we don't need scrolling - just show/hide images
        if (this.mql.matches && this.elements.thumbnailsVertical) {
          // Reset scroll position to 0 for single image view
          const mediaList = activeMedia.parentElement;
          if (mediaList) {
            mediaList.scrollLeft = 0;
          }
        } else if (!this.mql.matches || this.elements.thumbnails) {
          // For mobile or horizontal thumbnails, use normal scroll behavior
          window.setTimeout(() => {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            
            const activeMediaRect = activeMedia.getBoundingClientRect();
            // Don't scroll page if the image is already in view
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
        }
        this.playActiveMedia(activeMedia);

        // Update vertical thumbnails
        if (this.elements.thumbnailsVertical) {
          const activeVerticalThumbnail = this.elements.thumbnailsVertical.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveVerticalThumbnail(activeVerticalThumbnail);
        }

        // Update horizontal thumbnails
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          const position = activeThumbnail ? activeThumbnail.dataset.mediaPosition : 1;
          this.announceLiveRegion(activeMedia, position);
        } else if (this.elements.thumbnailsVertical) {
          const activeVerticalThumbnail = this.elements.thumbnailsVertical.querySelector(`[data-target="${mediaId}"]`);
          const position = activeVerticalThumbnail ? activeVerticalThumbnail.dataset.mediaPosition : 1;
          this.announceLiveRegion(activeMedia, position);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      setActiveVerticalThumbnail(thumbnail) {
        if (!this.elements.thumbnailsVertical || !thumbnail) return;

        // Remove active class from all vertical thumbnails
        this.elements.thumbnailsVertical
          .querySelectorAll('.thumbnail-list__item-vertical')
          .forEach((element) => element.classList.remove('active'));
        
        // Add active class to current thumbnail
        thumbnail.classList.add('active');

        // Update aria-current
        this.elements.thumbnailsVertical
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        const button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', true);
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
